import * as z from "zod";
function validateCPF(cpf) {
    var cleanCPF = cpf.replace(/[^\d]/g, "");
    if (cleanCPF.length !== 11)
        return false;
    if (/^(\d)\1{10}$/.test(cleanCPF))
        return false;
    var sum = 0;
    var remainder;
    for (var i = 1; i <= 9; i++) {
        sum += parseInt(cleanCPF.substring(i - 1, i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11)
        remainder = 0;
    if (remainder !== parseInt(cleanCPF.substring(9, 10)))
        return false;
    sum = 0;
    for (var i = 1; i <= 10; i++) {
        sum += parseInt(cleanCPF.substring(i - 1, i)) * (12 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11)
        remainder = 0;
    if (remainder !== parseInt(cleanCPF.substring(10, 11)))
        return false;
    return true;
}
export var formSchema = z.object({
    fullName: z.string().min(1, "O nome completo é obrigatório"),
    email: z.email("Digite um e-mail válido").min(1, "O e-mail é obrigatório"),
    cpf: z
        .string()
        .min(1, "O CPF é obrigatório")
        .refine(function (cpf) {
        var cleanCPF = cpf.replace(/[^\d]/g, "");
        return cleanCPF.length === 11 && validateCPF(cleanCPF);
    }, { message: "CPF inválido" }),
    sistema: z.string().min(1, "Selecione um sistema"),
    categoria: z.string().min(1, "Selecione uma categoria"),
    description: z
        .string()
        .trim()
        .min(10, "A descrição deve ter pelo menos 10 caracteres")
        .max(4000, "Máximo de 4000 caracteres"),
});
export var SISTEMA_OPTIONS = [
    { value: "GOV_PI", label: "GOV.PI" },
    { value: "MORAR_BEM", label: "Morar Bem" },
];
export var CATEGORIAS_POR_SISTEMA = {
    GOV_PI: [
        { value: "1", label: "Alterar cadastro", idGLPI: 1 },
        { value: "2", label: "Atualização de dados no Gov.pi", idGLPI: 2 },
        { value: "3", label: "Cancelar/Bloquear Acesso", idGLPI: 3 },
        { value: "4", label: "Correção de selo Gov.pi", idGLPI: 4 },
        { value: "5", label: "Dúvidas", idGLPI: 5 },
        { value: "6", label: "Erro/Indisponibilidade", idGLPI: 6 },
        { value: "7", label: "Liberar Acesso", idGLPI: 7 },
        { value: "8", label: "Manutenção", idGLPI: 8 },
        { value: "9", label: "Novo Cadastro", idGLPI: 9 },
        { value: "10", label: "Redefinição de Senha", idGLPI: 10 },
    ],
    MORAR_BEM: [
        { value: "11", label: "Bugs/Erros", idGLPI: 11 },
        { value: "12", label: "Melhorias", idGLPI: 12 },
    ],
};
